import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";

import appSettingsReducer from "../storeSlices/appSettings";
import approvePhotoDataReducer from "../storeSlices/approvePhotoData";
import loginReducer from "../storeSlices/login";
import notificationReducer from "../storeSlices/notification";
import { emptySplitApi } from "./emptyApi";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    appSettings: appSettingsReducer,
    notification: notificationReducer,
    approvePhotoData: approvePhotoDataReducer,
    [emptySplitApi.reducerPath]: emptySplitApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Из-за загрузки файлов с сервера возникали ошибки
        // Игнорируем проверку для кэша RTK Query
        ignoredPaths: ["api"],
        ignoredActions: ["api/executeQuery/fulfilled"],
      },
    }).concat(emptySplitApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
